<main [class.inactive]="interact.loading">
  <swapp-toast></swapp-toast>
  <swapp-header></swapp-header>
  <router-outlet></router-outlet>
  <swapp-help-widget></swapp-help-widget>
  <swapp-footer></swapp-footer>
  <swapp-loader *ngIf="interact.loading"></swapp-loader>
</main>